import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Spinner,
  DataTable,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { XIcon, CheckIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";
import moment from "moment";

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [ts, setTs] = useState("");

  const [result, setResult] = useState("");
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/users/${id}`);
      setResult(responseItem.data.data);
      responseItem.data.data.professor &&
        responseItem.data.data.professor.id !== null &&
        setSelectedProfessor(String(responseItem.data.data.professor.id));
      responseItem.data.data.orders &&
        setOrders(
          responseItem.data.data.orders.map((item, index) => [
            item?.id,

            item?.course
              ? getFirstNonNullValue(item?.course?.title)
              : item?.lecture
              ? getFirstNonNullValue(item?.lecture?.name)
              : getFirstNonNullValue(item?.note?.name),
            item?.purchased_price !== null ? item?.purchased_price : "-",
            item?.verified_from ? item?.verified_from : "-",
          ])
        );
    } catch (error) {
      console.log(error);
    }
  }
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{ onAction: () => navigate("/admin/users") }}
      title={result?.name}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text as="p" fontWeight="semibold">
              USER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Name</b>
                <br /> {result?.name ? result?.name : "-"}
              </Text>

              <Text breakWord>
                <b>Phone</b>
                <br /> {result?.phone ? result?.phone : "-"}
              </Text>
              <Text breakWord>
                <b>Email</b>
                <br /> {result?.email ? result?.email : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Created at</b>
                <br />{" "}
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Image</b>
                <br />{" "}
                {result?.image ? (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => window.open(result?.image, "_blank")}
                  >
                    <Thumbnail source={result?.image} size="large"></Thumbnail>
                  </div>
                ) : (
                  "-"
                )}
              </Text>

              <Text breakWord>
                <b>University</b>
                <br />{" "}
                {result?.academic_profile?.university
                  ? getFirstNonNullValue(result.academic_profile.university.name)
                  : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
        <Card>
          <FormLayout>
            <Text as="p" fontWeight="semibold">
              ORDERS
            </Text>

            {orders?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    ID
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Course / Lecture / Note Purchased
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Amount
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Payment Method
                  </Text>,
                ]}
                rows={orders}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : orders !== null ? (
              <Text>No orders found for this user</Text>
            ) : null}
          </FormLayout>
        </Card>
      </FormLayout>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default UserDetails;
